"use client";
import styles from "@styles/whatsapp-chat.module.css";
import Link from "next/link";
import { FaSquareWhatsapp } from "react-icons/fa6";
import { usePathname } from "next/navigation";
import React from "react";

const whatsAppChatLink: string =
  "https://wa.me/2349069730290?text=Hello%20OICNM%20Support!%20I%20need%20assistance%20with...";

const excludedPaths: string[] = ["/dashboard/admission-letter"];

export default function WhatsAppChat() {
  const pathname = usePathname();

  if (excludedPaths.includes(pathname)) {
    return null;
  }

  return (
    <section className={styles.whatsapp_chat_container}>
      <Link
        aria-label="Chat On WhatsApp"
        target="_blank"
        rel="noopener noreferrer"
        href={`${whatsAppChatLink}`}
      >
        <FaSquareWhatsapp className={styles.chat_icon} />
      </Link>
    </section>
  );
}
